export type SortValue = string | number | null | undefined

const isNilSortValue = (value: SortValue): boolean =>
  value == null || value === '' || (typeof value === 'number' && Number.isNaN(value))

/** Compare sort values: nullish always last; direction flips only real values. */
export const compareSortValues = (a: SortValue, b: SortValue, direction: 'asc' | 'desc'): number => {
  const aNil = isNilSortValue(a)
  const bNil = isNilSortValue(b)
  if (aNil && bNil) return 0
  if (aNil) return 1
  if (bNil) return -1
  const cmp =
    typeof a === 'number' && typeof b === 'number'
      ? a - b
      : String(a).localeCompare(String(b), undefined, { numeric: true })
  return direction === 'asc' ? cmp : -cmp
}
